module.exports = __webpack_public_path__ + "static/media/rule14_onDark_logo.607f21de.png";